// react
import { useState } from 'react';

// types
import { Country, Option } from '../../../@types';

// hooks
import { useFetch } from '../../../hooks/useFetch';

// fields
import { Select, SelectProps } from '../Select/Select';

// props
export interface SelectCountryProps extends Omit<SelectProps, 'options'> {
	valueType?: 'CODE' | 'ID';
}

export const SelectCountry = ({ valueType = 'CODE', ...props }: SelectCountryProps) => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// state
	const [countries, setCountries] = useState<Country[]>([]);

	// vars
	const optionsCountries: Option[] = countries.map((country) => {
		return {
			label: country.name,
			value: valueType === 'CODE' ? country.code : String(country.id),
		};
	});

	useFetch({
		url: `${process.env.REACT_APP_API_URL}/countries`,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setCountries(res.data);
			}
		},
	});

	return <Select name="country" {...props} options={optionsCountries} />;
};
